<template>
  <v-row no-gutters>
    <v-col cols="4" v-for="menu in menus" :key="menu.id">
      <v-sheet outlined class="text-center pa-3" style="height:5em;" @click="goto(menu.path)">
        <v-icon size="40">{{ menu.icon }}</v-icon>
        <div class='text-truncate'>{{ menu.title }}</div>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    data(){
      return {
        users: [],
        menus: [
          { id:1, title: 'Customer', icon: 'mdi-account-multiple', path: 'users' },
          { id:2, title: 'Product', icon: 'mdi-package-variant', path: 'products' },
          { id:3, title: 'Order', icon: 'mdi-cart-arrow-down', path: 'orders' },
          { id:4, title: 'Report', icon: 'mdi-file-chart' }
        ]
      }
    },
    created(){
      if(this.$store.state.users === null) this.getUsers()
      if(this.$store.state.cities === null) this.getCities()
      if(this.$store.state.products === null) this.getProducts()
    },
    methods:{
      getUsers(){
        this.axios.get('users').then( (res) => {
          this.$store.commit('mutate', { prop: 'users', data: res.data })
        }).catch( (err) => {
          console.log(err)
        })
      },

      getProducts(){
        this.axios.get('products').then( (res) => {
          this.$store.commit('mutate', { prop: 'products', data: res.data })
        }).catch( (err) => {
          console.log(err)
        })
      },

      getCities(){
        this.axios.get('address/cities').then( (res) => {
          this.$store.commit('mutate', { prop: 'cities', data: res.data })
        }).catch( (err) => {
          console.log(err)
        })
      },
      goto(path){
        this.$router.push(path)
      }
    }
  }
</script>

<style scoped>
</style>